import { render, staticRenderFns } from "./VisitorAttributes.vue?vue&type=template&id=12067608&scoped=true"
import script from "./VisitorAttributes.vue?vue&type=script&lang=js"
export * from "./VisitorAttributes.vue?vue&type=script&lang=js"
import style0 from "./VisitorAttributes.vue?vue&type=style&index=0&id=12067608&prod&lang=scss"
import style1 from "./VisitorAttributes.vue?vue&type=style&index=1&id=12067608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12067608",
  null
  
)

export default component.exports